<div class="m-y-20 text-center">
  <div class="d-flex align-items-center justify-content-center">
    <div style="width: 30px">
      @if (offset > 1) {
        <fa-icon class="circle-icon-btn" [animation]="loadingPrevious ? 'spin' : undefined" [icon]="loadingPrevious ? 'spinner' : 'chevron-left'" (click)="onPaginate('previous')"></fa-icon>
      }
    </div>
    <small class="d-block m-x-10">
      {{ offset }}
      @if (totalPages) {
        of {{ totalPages }}
      }
    </small>

    <div style="width: 30px">
      @if (hasNext !== undefined ? hasNext : resultsLength === limit) {
        <fa-icon class="circle-icon-btn" [animation]="loadingNext ? 'spin' : undefined" [icon]="loadingNext ? 'spinner' : 'chevron-right'" (click)="onPaginate('next')"></fa-icon>
      }
    </div>
  </div>
  @if (totalResults) {
    <div>
      <small>({{ totalResults }} Total Results)</small>
    </div>
  }
</div>
